const OneTrustGroupEnum = {
    STRICTLY: 'C0001',
    PERFORMANCE: 'C0002',
    FUNCTIONAL: 'C0003',
    TARGETING: 'C0004',
    SOCIAL: 'C0005',
    GOOGLE: 'gad'
};

export default OneTrustGroupEnum